import { render, staticRenderFns } from "./UploadPreVisualizacao.vue?vue&type=template&id=03403b95&scoped=true"
import script from "./UploadPreVisualizacao.vue?vue&type=script&lang=js"
export * from "./UploadPreVisualizacao.vue?vue&type=script&lang=js"
import style0 from "./UploadPreVisualizacao.vue?vue&type=style&index=0&id=03403b95&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03403b95",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03403b95')) {
      api.createRecord('03403b95', component.options)
    } else {
      api.reload('03403b95', component.options)
    }
    module.hot.accept("./UploadPreVisualizacao.vue?vue&type=template&id=03403b95&scoped=true", function () {
      api.rerender('03403b95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/UploadPreVisualizacao.vue"
export default component.exports